import { Unit } from '../unit';
import { UpdateState, UpdateStateItem } from './../../shared/update-state-item';

export class MaintenanceStrategyAttribute implements UpdateStateItem  {
  id: string;
  name: string;
  value: string;
  uomId: string;
  uom: Unit;
  maintenanceStrategyId: string;
  rowNumber: number;

  public state: UpdateState = UpdateState.Unchanged;

  loadFromJson(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.value = data.value;
    this.uomId = data.uomId;
    this.rowNumber = data.rowNumber;

    if (data.uom) {
      this.uom = new Unit();
      this.uom.loadFromJson(data.uom);
    }

    this.maintenanceStrategyId = data.maintenanceStrategyId;
  }
}
